import React from 'react';

/** App illustration — a browser window (top bar + dots) framing a small app grid. */
const AppWindow = () => (
  <div className="ill-appwin" aria-hidden="true">
    <div className="ill-appwin-bar">
      <span className="ill-appwin-dot"></span>
      <span className="ill-appwin-dot"></span>
      <span className="ill-appwin-dot"></span>
    </div>
    <div className="ill-appwin-body">
      <span className="ill-appwin-cell"></span>
      <span className="ill-appwin-cell"></span>
      <span className="ill-appwin-cell ill-appwin-cell-accent"></span>
      <span className="ill-appwin-cell"></span>
    </div>
  </div>
);

export default AppWindow;
